import ApiService from "./base.api.service";
import store from "@/store";

class AuthApi extends ApiService {
  constructor() {
    super();
  }

  get baseURL() {
    return store.state.config.authUrl;
  }
}

export default new AuthApi;
